<template>
  <div class="checkoutrightbody">
    <div class="shoppingcarlistwrap">
      <transition>
        <div class="scrollHint" v-if="scrollOff">Scroll for more items ?</div>
      </transition>
      <div :class="orders_query ? 'shoppingcarlist borderbottom' : 'shoppingcarlist'">
        <div class="row align-items-center shoppingcarlistsitem" v-for="(item, index) in line_items" :key="index">
          <div class="smallphotowarp">
            <span>{{ item.qty }}</span>
            <div class="smallphoto">
              <!-- 要是商品被删了会导致thank you页面的product属性也不存�? -->
              <img
                v-if="item.feature_image"
                :src="item.feature_image.thumbnail ? item.feature_image.thumbnail : defaultImage"
                alt
                class="lazyload"
                @error.once="imageFailure($event, defaultImage)"
              />
              <img v-else :src="defaultImage" alt />
            </div>
          </div>
          <div class="col productmes">
            <div>{{ item.order_item_name }}</div>
            <div class="variant" v-if="item.attrs.constructor == Object">
              <template v-for="(subitem, subindex) in item.attrs">
                <span v-if="subitem != 'Default Title'" :key="subindex">{{ subitem }}</span>
              </template>
            </div>
            <div v-if="item.properties">
              <template v-for="(subitem, subindex) in item.properties">
                <template v-if="subitem">
                  <div class="variant" :key="subindex + subitem" v-if="subitem.search(/^https?:\/\//) == -1">
                    {{ subindex }} : {{ subitem }}
                  </div>
                  <span class="variant" v-else :key="subindex + subitem">{{ subindex }} :
                    <a
                      class="preview"
                      :href="subitem"
                      @click.prevent="downloadFile(subitem, subitem)"
                      >Preview
                    </a>
                  </span>
                </template>
              </template>
            </div>
          </div>
          <div class="price" style="text-align: right">
            <div style="font-weight: bold;">
              {{currencySymbol}}{{ (item.line_total - 0).toFixed(2) }}
            </div>
            <div
              v-if="item.line_subtotal - 0 > item.line_total - 0 ? item.line_subtotal : 0"
              class="regular_price_text"
              style="text-decoration: line-through"
            >
              {{ currencySymbol }}{{ (item.line_subtotal - 0).toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-discountcode v-if="orders_query && ((mb_checkout_right && isMobile) || (!mb_checkout_right && !isMobile)) " :cart="cart"></v-discountcode>
    <div class="computed">
      <div class="computedlist">
        <div>
          <span>{{ $t('shopping.subtotal') }}</span>
          <span> {{ currencySymbol }}{{ (order_subtotal - 0).toFixed(2) }} </span>
        </div>
        <div v-if="discount_cart >= 0.01 || coupons.length || rules.length || couponRecord.length">
          <!-- 有coupon_record时无需显示coupons+rules里的优惠 -->
          <span>
            {{ $t('shopping.discount') }}
            <span v-if="couponRecord.length">
              <i v-for="item in couponRecord" :key="item.code">
                <i v-if="item.code != 'buy x get x'" class="iconfont icon-cm-biaoqian">
                  &nbsp; {{ item.discount_type=='wdr_code_discount' ? item.code : item.description }}
                </i>
              </i>
            </span>
            <span v-else>
              <i v-for="item in coupons" :key="item.code">
                <i v-if="item.code != 'buy x get x'" class="iconfont icon-cm-biaoqian">
                  &nbsp; {{ item.auto_coupon ? item.description : item.code }}
                </i>
              </i>
              <i v-for="(item, index) in rules" :key="index + item.code" class="iconfont icon-cm-biaoqian">
                &nbsp; {{ item.description }}
              </i>
            </span>
            <!-- 组合优惠不包括在coupon_record -->
            <span>
              <i v-for="(item, index) in rules" :key="index + item.discount_type">
                <i v-if="item.amount > 0" class="iconfont icon-cm-biaoqian">
                  &nbsp; {{ item.discount_type }}
                </i>
              </i>
            </span>
          </span>
          <span v-if="free_shipping">{{ $t('shopping.free_shipping') }}</span>
          <span v-else> - {{ currencySymbol }}{{ (discount_cart - 0).toFixed(2) }} </span>
        </div>
        <div
          v-if="
            this.$store.state.shipping_insurance_price !== 0 &&
            (this.$store.state.shipping_insurance_price || order_insurance_price)
          "
        >
          <span>{{ $t('shopping.shipping_insurance') }}</span>
          <span v-if="$store.state.shipping_insurance_price">
            {{ currencySymbol }}{{ ($store.state.shipping_insurance_price - 0).toFixed(2) }}
          </span>
          <span v-else> {{ currencySymbol }}{{ (order_insurance_price - 0).toFixed(2) }} </span>
        </div>
        <div v-if="shippingVisibility">
          <span>{{ $t('shopping.shipping') }}</span>
          <span v-if="!cart.ID" >
            <span a="1" v-if="$store.state.order_shipping === ''" :style="{fontWeight:news_cart.shipping.chosen_method &&order_shipping != '0' ? 'bold': 400 }">{{
              news_cart.shipping.chosen_method
                ? order_shipping != '0'
                  ? `${currencySymbol}${(order_shipping - 0).toFixed(2)}`
                  : $t('shopping.free')
                : $t('shopping.calculated_at_next_step')
            }}</span>
            <span v-else a="2" :style="{fontWeight:$store.state.order_shipping ? 'bold': 400 }">{{
              $store.state.order_shipping
                ? `${currencySymbol}${($store.state.order_shipping - 0).toFixed(2)}`
                : $t('shopping.free')
            }}</span>
          </span>
          <span v-else :style="{fontWeight:order_shipping == '0.00' ? 400: 'bold'}">{{
            order_shipping == '0.00' ? $t('shopping.free') : `${currencySymbol}${order_shipping}`
          }}</span>
        </div>
      </div>
      <div class="computetotal">
        <span>{{ $t('shopping.total') }}</span>
        <p>
          <i>{{ checkoutcurrency }}</i>
          <span>{{ currencySymbol }}{{ computedTotal }}</span>
          <!-- <span>${{this.$store.state.order_shipping||this.$store.state.shipping_insurance_price?(order_total-order_shipping-order_insurance_price+this.$store.state.order_shipping-0+this.$store.state.shipping_insurance_price-0).toFixed(2):(order_total-0).toFixed(2)}}</span> -->
        </p>
      </div>
      <!-- 汇率换算提示 -->
      <div class="computetotalTip" v-if="currencyConversionTips && checkoutcurrency!=$store.state.pricetype">
          <span>
             {{
                `${getSymbolFromCurrency($store.state.pricetype)}  ${computePrice(
                  computedTotal
                )}`
              }}
         </span>
         <i>{{ $t("exchange.rate.conversion.tips") }}</i>
      </div>
      <div class="order-tips" v-if="order_tip">
        <img v-if="order_tip_img" :src="order_tip_img" />
      </div>
    </div>
  </div>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
import vDiscountcode from "./discountcode";
import { mapState } from 'vuex';
export default {
  props: ['orders_query', 'cart', 'order_tip', 'order_tip_img','mb_checkout_right'],
  data() {
    return {
      // defaultImage,
      line_items: [], //购物车商�?
      order_subtotal: 0, //折扣前总价
      order_shipping: 0, //最终邮�?
      coupons: [], //优惠券列�?
      rules: [], //满送优惠券列表
      order_total: 0, //最终总价
      discount_cart: 0, //优惠了价�?
      scrollOff: false,
      order_insurance_price: 0, //最终运费险价格
      free_shipping: false, //是否免运费优惠券
      couponRecord: [], //所使用的全部优惠券

    }
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
  },
  computed: {
    shippingVisibility(){
      return  this.news_cart?.address?.country || this.checkout_setting === 'three_step_checkout' || this.news_cart?.ID
    },
    computedTotal() {
      let cartTotal = this.order_total
      if (
        this.$store.state.order_shipping !== '' &&
        this.news_cart.shipping &&
        this.news_cart.shipping.chosen_method
      ) {
        cartTotal = cartTotal - this.order_shipping + this.$store.state.order_shipping
      } else if (this.$store.state.order_shipping !== '') {
        cartTotal += this.$store.state.order_shipping
      }
      if (this.$store.state.shipping_insurance_price !== '' && this.news_cart.shipping_insurance) {
        cartTotal = cartTotal - this.order_insurance_price + this.$store.state.shipping_insurance_price
      } else if (this.$store.state.shipping_insurance_price !== '') {
        cartTotal = cartTotal + this.$store.state.shipping_insurance_price
      }
      return (cartTotal - 0).toFixed(2)
    },
    ...mapState({
      isMobile: ({ isMobile }) => isMobile,
      // 结账货币
      checkoutcurrency: ({ options }) => options?.base?.woocommerce_currency || null,
      // 结账货币符号
      currencySymbol: ({ options }) => options?.base?.currency_symbol || null,
      // 汇率换算提示
      currencyConversionTips: ({ options }) => options?.theme?.global?.currency_conversion_tips || null,
      news_cart ({news_cart}) {
        return Object.values(news_cart).length ? news_cart : this?.cart || {}
      },
      checkout_setting: ({ options }) => options?.base?.checkout_setting,
    })
  },
  methods: {
    updateCartMes(newcartmes) {
      // 购物车页面的字段
      this.line_items = []
      for (let item in newcartmes.cart) {
        let { product, line_subtotal, line_total, quantity, properties } = newcartmes.cart[item]
        let attrs = {}
        if (newcartmes.cart[item].variant) {
          newcartmes.cart[item].variant.attrs.forEach((item) => {
            attrs[item.name] = item.value
          })
        } else {
          attrs = []
        }
        this.line_items.push({
          order_item_name: product.post_title,
          line_subtotal: line_subtotal,
          line_total: line_total,
          qty: quantity,
          attrs,
          properties,
          feature_image: newcartmes.cart[item].variant
            ? newcartmes.cart[item].variant.feature_image
              ? newcartmes.cart[item].variant.feature_image
              : newcartmes.cart[item].product.feature_image
            : newcartmes.cart[item].product.feature_image,
        })
      }
      this.order_subtotal = newcartmes.cart_subtotal
      this.coupons = Object.values(newcartmes.coupons)
      this.rules = Object.values(newcartmes.rules)
      this.couponRecord = Object.values(newcartmes.coupon_record)
      if (this.coupons.length) {
        this.coupons.some((item) => {
          this.free_shipping = item?.free_shipping
        })
      }
      this.order_total = newcartmes.cart_total
      this.order_shipping = newcartmes.shipping_total
      this.discount_cart = newcartmes.discount_cart
      if (newcartmes.fees['shipping-insurance']) {
        this.order_insurance_price = newcartmes.fees['shipping-insurance'].total
      }
    },
  },
  mounted() {
    console.log(this.cart,'cart');
    if (this.cart.ID) {
      // thank页面的字段
      let { line_items = [], order_shipping = 0, order_total = 0, fees = [], coupons = [], rules = [], buy_x_get_x_discount = 0, discount_record = [] } = this.cart
      this.line_items = line_items
      this.order_shipping = order_shipping
      this.order_total = order_total
      // 折扣前总价order_subtotal在thank页面是总价减去邮费加上折扣的价�?
      this.line_items.forEach((item) => {
        this.order_subtotal += item.line_subtotal - 0
      })
      this.discount_cart = this.order_subtotal - (order_total - 0) + (order_shipping - 0) + (buy_x_get_x_discount - 0)
      if (fees[0]) {
        let { line_total, fee_amount } = fees[0]
        this.order_insurance_price = line_total
        this.discount_cart += fee_amount - 0
      }
      //thank页面的百分比优惠券已经是计算后的
      this.coupons = coupons.map((item) => {
        if (item.free_shipping) {
          this.free_shipping = item.free_shipping
        }
        //购物车页面和thank页面的字段不一�?
        return {
          auto_coupon: item.auto_coupon,
          code: item.order_item_name,
          description: item.content,
          amount:item.value,
        }
      })
      this.rules = rules.map((item) => {
        return {
          code:item.code,
          description: item.rule_title,
        }
      })
      this.couponRecord = discount_record
    } else {
      this.$store.dispatch('change_news_cart', this.cart)
    }
    window.setTimeout(() => {
      if (this.$(window).width() > 991 && this.$('.shoppingcarlist')[1].clientHeight / this.$(window).height() > 0.53) {
        this.scrollOff = true
        this.$('.shoppingcarlist').scroll(() => {
          this.scrollOff = false
          this.$('.shoppingcarlist').unbind()
        })
      }
    }, 1000)
  },
  components: {
    vDiscountcode,
  },
  watch: {
    async '$store.state.update_cart'() {
      if (this.$store.state.update_cart) {
        try {
          let res = await this.$axios.get('/api/store/cart')
          this.updateCartMes(res.data)
        } catch (error) {
          console.log(error.response)
        }
      }
    },
    '$store.state.news_cart'(newV) {
      if (window.performance.navigation.type == 2 && window.location.pathname.includes('orders')) {
        return;
      }
      this.updateCartMes(newV)
    },
  },
}
</script>
<style scoped lang='scss'>
.checkoutrightbody {
  color: black;

  .borderbottom {
    border-bottom: 1px solid #e5e5e5;
  }

  .shoppingcarlistwrap {
    position: relative;
    .shoppingcarlist {
      padding-top: 10px;
      .shoppingcarlistsitem {
        padding: 0 15px;
        margin-bottom: 14px;
        font-size: 14px;
        .smallphotowarp {
          position: relative;
          span {
            height: 21px;
            line-height: 21px;
            opacity: 0.6;
            font-size: 12px;
            position: absolute;
            padding: 0 7px;
            top: -8px;
            right: -5px;
            border-radius: 15px;
            background-color: black;
            color: white;
            text-align: center;
          }
          .smallphoto {
            width: 64px;
            height: 64px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #e5e5e5;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              // width: 100%;
              // height: 100%;
              // position: absolute;
              inset: 0px;
              max-width: 100%;
              max-height: 100%;
              margin: auto;
            }
          }
        }
        .productmes {
          & > div:first-child {
            font-size: 16px;
            color: #323232;
            font-weight: bold;
          }
          .variant {
            display: block;
            font-size: 12px;
            color: #717171;
            span:not(:last-child)::after {
              content: ' / ';
            }
          }
          .preview {
            color: #717171;
          }
          .preview:hover {
            opacity: 0.7;
            cursor: pointer;
          }
        }
      }
    }
    .scrollHint {
      position: absolute;
      z-index: 2;
      bottom: 20px;
      left: 50%;
      color: #fafafa;
      border-radius: 30px;
      font-size: 12px;
      transform: translateX(-50%);
      padding: 7.2px 14.4px;
      background-color: rgba(50, 50, 50, 0.85);
      &:hover + .shoppingcarlist {
        overflow-y: auto !important;
      }
    }
  }

  .computed {
    border-top: 1px solid #e5e5e5;

    .computedlist {
      padding-top: 21px;
      padding-bottom: 21px;
      border-bottom: 1px solid #e5e5e5;

      div {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #535353;
        span:last-child {
          color: #323232;
          font-weight: bold;
          white-space: nowrap;
        }
        span {
          word-break: break-word;
          i {
            margin-left: 5px;
            font-style: normal;
          }
        }
      }

      & > div:not(:first-child) {
        margin-top: 10.5px;
      }
    }
    .order-tips {
      img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: auto;
      }
    }

    .computetotal {
      padding-top: 16px;
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      p {
        margin-bottom: 0;
        font-weight: bold;
        i {
          font-size: 24px;
          font-style: normal;
          //vertical-align: middle;
          margin-right: 6px;
          color: #717171;
        }

        span {
          font-size: 24px;
          color: #323232;
        }
      }
    }
    .computetotalTip{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      span{
        font-size: 14px;
        font-weight: 700;
      }
      i{
        font-size: 12px;
        font-weight: 400;
        padding: 10px 0;
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.2s ease;
}
.v-enter {
  bottom: -30px !important;
}
.v-leave-to {
  bottom: 60px !important;
  opacity: 0 !important;
}

@media screen and( min-width: 992px) {
  .checkoutrightbody {
    .shoppingcarlistwrap {
      overflow: hidden;
      .shoppingcarlist {
        max-height: 55vh !important;
        overflow: hidden !important;
        &:hover {
          overflow-y: auto !important;
        }
      }
    }
  }
}
@media screen and( max-width: 992px) {
  .checkoutrightbody {
    .shoppingcarlistwrap {
      .scrollHint {
        display: none;
      }
      .shoppingcarlist {
        .shoppingcarlistsitem {
          .productmes {
            & > div:first-child {
              font-size: 14px !important;
              color: #323232;
            }
          }
        }
      }
    }
    .computed {
      .order-tips {
        margin-bottom: 20px !important;
      }
    }
  }
}
</style>
